<template>
  <div class="mx-1">
    <BasePageContainer class="mt-8 bg-white p-4 position-relative">
      <div class="d-flex align-items-center">
        <span
          class="lock-icon material-icons">
          lock
        </span>
        <p class="fs-m text--grey05">
          このページはすべて限定公開です
        </p>
      </div>
      <div
        class="d-flex flex-column align-items-end position-absolute p-2"
        style="right: 16px; top: 16px;">
        <router-link
          :to="`/members/${userId}`"
          class="d-flex align-items-center font-weight-bold fs-m text-decoration-none">
          ノートに戻る
        </router-link>
        <IconTextButton
          class="font-weight-bold mt-2"
          active
          :icon-size="30"
          icon="arrow_drop_down"
          @click="scrollToBottom">
          最下部へ
        </IconTextButton>
      </div>
      <ActivitiesSection
        class="mt-2"
        :user-id="userId"
        :record-days="recordDays"
        :evaluation-months="evaluationMonths" />
      <hr class="my-4">
      <EmergencyContactsSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :emergency-contacts="emergencyContacts" />
      <hr class="mt-3 mb-4">
      <PastDepartmentsSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :past-departments="pastDepartments" />
      <hr class="my-4">
      <BodyMeasurementsSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :body-measurements="bodyMeasurements" />
      <hr class="my-4">
      <AcademicRecordsSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :academic-semesters="academicSemesters" />
      <hr class="my-4">
      <PathSurveysSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :path-surveys="pathSurveys" />
      <hr class="my-4">
      <PathActivitiesSection
        class="mt-4"
        :can-edit="isMyProfile"
        :user-id="userId"
        :path-activities="pathActivities">
        <template #comments>
          <PathActivityCommentsSection
            class="mt-2"
            :user-id="userId"
            :comments="pathActivityComments"
            @refetch="fetchPathActivityComments" />
        </template>
      </PathActivitiesSection>
      <hr class="my-4">
      <FinalDestinationSection
        :can-edit="isManager || isMyProfile"
        class="mt-4"
        :user-id="userId"
        :final-destination="finalDestination" />
      <hr class="my-4">
      <ManagerCommentsSection
        v-if="isManager"
        class="mt-4"
        :user-id="userId"
        :comments="managerComments"
        @refetch="fetchManagerComments" />
      <div class="d-flex flex-column align-items-end mt-2">
        <router-link
          :to="`/members/${userId}`"
          class="d-flex align-items-center font-weight-bold fs-m text-decoration-none">
          ノートに戻る
        </router-link>
        <IconTextButton
          class="font-weight-bold mt-2"
          active
          :icon-size="30"
          icon="arrow_drop_up"
          @click="scrollToTop">
          最上部へ
        </IconTextButton>
      </div>
    </BasePageContainer>
    <FixedBottomLeftArea v-if="showNotificationReturnButton">
      <FixedBottomLeftButton
        icon="undo"
        @click="goBackToNotifications">
        通知に戻る
      </FixedBottomLeftButton>
    </FixedBottomLeftArea>
    <FixedBottomLeftArea v-else-if="showRecordListReturnButton">
      <button
        class="record-list-return-btn"
        @click="goBackToRecordList">
        <span class="material-icons record-list-return-btn__icon">undo</span>
        一覧に戻る
      </button>
    </FixedBottomLeftArea>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import ActivitiesSection from '@/components/view/profile/ActivitiesSection.vue'
import PathActivitiesSection from '@/components/view/profile/path_activities/PathActivitiesSection.vue'
import EmergencyContactsSection from '@/components/view/profile/emergency_contacts/EmergencyContactsSection.vue'
import PathSurveysSection from '@/components/view/profile/path_surveys/PathSurveysSection.vue'
import FinalDestinationSection from '@/components/view/profile/final_destination/FinalDestinationSection.vue'
import PathActivityCommentsSection from '@/components/view/profile/path_activities/PathActivityCommentsSection.vue'
import PastDepartmentsSection from '@/components/view/profile/past_departments/PastDepartmentsSection.vue'
import BodyMeasurementsSection from '@/components/view/profile/body_measurements/BodyMeasurementsSection.vue'
import AcademicRecordsSection from '@/components/view/profile/academic_records/AcademicRecordsSection.vue'
import ManagerCommentsSection from '@/components/view/profile/manager_comments/ManagerCommentsSection.vue'
import IconTextButton from '@/components/parts/IconTextButton.vue'
import FixedBottomLeftArea from '@/components/parts/FixedBottomLeftArea.vue'
import FixedBottomLeftButton from '@/components/parts/FixedBottomLeftButton.vue'
import notificationReturn from '@/components/mixin/notificationReturn'
export default {
  components: {
    BasePageContainer,
    ActivitiesSection,
    PathActivitiesSection,
    EmergencyContactsSection,
    PathSurveysSection,
    FinalDestinationSection,
    PathActivityCommentsSection,
    PastDepartmentsSection,
    BodyMeasurementsSection,
    AcademicRecordsSection,
    ManagerCommentsSection,
    IconTextButton,
    FixedBottomLeftArea,
    FixedBottomLeftButton,
  },
  mixins: [notificationReturn],
  data() {
    return {
      initialized: false,
      recordDays: 0,
      evaluationMonths: 0,
      emergencyContacts: [],
      pastDepartments: [],
      bodyMeasurements: [],
      academicSemesters: [],
      pathSurveys: null,
      pathActivities: [],
      pathActivityComments: [],
      finalDestination: null,
      managerComments: [],
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isManager']),
    userId() {
      return this.$route.params.id
    },
    isMyProfile() {
      return this.userId === this.user.id
    },
    backTo() {
      return this.$route.query.backTo || null
    },
    backToMemberId() {
      return this.$route.params.id || null
    },
    showRecordListReturnButton() {
      return this.backTo === 'recordList' || this.backTo === 'recordMandalaList'
    },
  },
  beforeRouteLeave(to, from, next) {
    const recordListRouteNames = [
      'recordListNoteRecords',
      'recordListBodyMeasurements',
      'recordListPathSurveys',
      'recordListAcademicRecords',
    ]
    if (recordListRouteNames.includes(to.name) && this.backToMemberId) {
      this.$store.commit('recordProfile/setReturnMemberId', this.backToMemberId)
    }
    next()
  },
  async created() {
    this.$store.commit('startLoading')
    const promises = [
      this.fetchActivityResultsRecordDays(),
      this.fetchMandalaGoalSelfEvaluationsEvaluationMonths(),
      this.fetchEmergencyContacts(),
      this.fetchPastDepartments(),
      this.fetchBodyMeasurements(),
      this.fetchAcademicSemesters(),
      this.fetchPathSurveys(),
      this.fetchPathActivities(),
      this.fetchPathActivityComments(),
      this.fetchFinalDestination(),
    ]
    if (this.isManager) {
      promises.push(this.fetchManagerComments())
    }
    await Promise.all(promises).finally(() => {
      this.initialized = true
      this.$store.commit('finishLoading')
    })

    if (this.$route.query.pathActivityId) {
      this.scrollToElement(this.$route.query.pathActivityId)
    }
    if (this.$route.query.pathActivityCommentId) {
      this.scrollToElement(this.$route.query.pathActivityCommentId)
    }
  },
  mounted() {
    // iOSのPWAではスクロールするまで要素が描画されないことがあるので、スクロールする
    setTimeout(() => {
      window.scrollTo(0, 1)
    }, 1)
  },
  methods: {
    fetchActivityResultsRecordDays() {
      return this.$axios.get('/profiles/statistics/activity-record-days/', {
        params: {
          user_id: this.userId,
        }
      }).then(res => {
        this.recordDays = res.data.recordDays
      })
    },
    fetchMandalaGoalSelfEvaluationsEvaluationMonths() {
      return this.$axios.get('/profiles/statistics/evaluation-months/', {
        params: {
          user_id: this.userId,
        }
      }).then(res => {
        this.evaluationMonths = res.data.evaluationMonths
      })
    },
    fetchEmergencyContacts() {
      return this.$axios.get('/profiles/emergency-contacts/', {
        params: {
          user_id: this.userId,
        },
      }).then((res) => {
        this.emergencyContacts = res.data.results || []
      })
    },
    fetchPastDepartments() {
      return this.$axios.get('/profiles/past-departments/', {
        params: {
          user_id: this.userId
        }
      }).then(res => {
        this.pastDepartments = res.data.results
      })
    },
    fetchBodyMeasurements() {
      return this.$axios.get('/profiles/body-measurements/', {
        params: {
          user_id: this.userId,
        },
      }).then((res) => {
        this.bodyMeasurements = res.data.results
      })
    },
    fetchAcademicSemesters() {
      return this.$axios.get('/profiles/academic-semesters/', {
        params: {
          user_id: this.userId,
        },
      }).then((res) => {
        this.academicSemesters = res.data.results
      })
    },
    fetchPathSurveys() {
      return this.$axios.get('/profiles/path-surveys/', {
        params: {
          user_id: this.userId,
          limit: 1,
        },
      }).then(res => {
        this.pathSurveys = res.data.results?.[0] || null
      })
    },
    fetchPathActivities() {
      return this.$axios.get('/profiles/path-activities/', {
        params: {
          user_id: this.userId,
          ordering: 'activity_at',
        }
      }).then(res => {
        this.pathActivities = res.data.results
      })
    },
    fetchPathActivityComments() {
      return this.$axios.get('/profiles/path-activity-comments/', {
        params: {
          user_id: this.userId,
          ordering: 'created_at',
        }
      }).then(res => {
        this.pathActivityComments = res.data.results
      })
    },
    fetchFinalDestination() {
      return this.$axios.get('/profiles/final-destination/', {
        params: {
          user_id: this.userId,
          limit: 1,
        },
      }).then((res) => {
        this.finalDestination = res.data.results?.[0] || null
      })
    },
    fetchManagerComments() {
      return this.$axios.get('/profiles/manager-comments/', {
        params: {
          user_id: this.userId,
          limit: 99999,
          ordering: 'created_at',
        },
      }).then((res) => {
        this.managerComments = res.data.results
      })
    },
    scrollToElement(elementId) {
      this.$nextTick(() => {
        const element = document.getElementById(elementId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      })
    },
    goBackToRecordList() {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss" scoped>
.lock-icon {
  color: $grey12;
  font-size: 1rem;
  border: solid 1px $grey11;
  border-radius: 50%;
  padding: 1px;
  margin-right: 2px;
}

$record-list-return-btn-shadow: rgba(0, 0, 0, 0.2);
$record-list-return-btn-icon-size: 1.5rem;

.record-list-return-btn {
  display: flex;
  align-items: center;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: $fs-m;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 8px $record-list-return-btn-shadow;

  &:hover {
    opacity: 0.85;
  }

  &__icon {
    font-size: $record-list-return-btn-icon-size;
    margin-right: 4px;
  }
}
</style>